import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getAvailableApplications } from "../../actions/UrlActions";
import UrlHelper from "../../utilities/UrlHelper";
import { ProductUtilities } from "@p1s/p1s-common-react/utilities";
import Header from "@p1s/p1s-common-react/Header";
import UsersUtility from "newApp/utilities/UsersUtility";
import { isEnterPressed, isShiftPressed, isTabPressed } from "newApp/utilities/EventsHelper";
import IconView from "@p1s/p1s-common-react/IconView";

export class ProductSelectorContainer extends Component {
    constructor (props) {
        super(props);

        this.firstProductId = 0;
        this.lastProductId = 0;
        this._onSignOut = this._onSignOut.bind(this);
        this.onProfileClick = this.onProfileClick.bind(this);
    }

    componentDidMount () {
        import('./_styles.scss');
        this.props.getAvailableApplications();
    }

    componentDidUpdate (prevProps) {
        if (this.props.applications?.length && this.props.applications.length !== prevProps.applications?.length) {
            this.setFocusToFirstProduct();
        }
    }

    setFocusToFirstProduct = () => this.firstProductRef?.focus();
    setFocusToLastProduct = () => this.lastProductRef?.focus();

    setRefToProduct = (ref, product) => {
        if (!this.firstProductRef) {
            this.firstProductRef = ref;
            this.firstProductId = product.id;
        }

        this.lastProductRef = ref;
        this.lastProductId = product.id;
    };

    onProductKeyDown = (e, product) => {
        if (isEnterPressed(e) && !product.isLocked) {
            e.preventDefault();
            window.location = product.url;

        }
        if (isTabPressed(e) && isShiftPressed(e) && product.id === this.firstProductId) {
            e.preventDefault();
            this.setFocusToLastProduct();
        }

        if (isTabPressed(e) && !isShiftPressed(e) && product.id === this.lastProductId) {
            e.preventDefault();
            this.setFocusToFirstProduct();
        }
    };

    getProductIcon (productConfiguration) {
        return <IconView icon={productConfiguration.icon} />;
    }

    getProductTile (product) {
        const productConfiguration = ProductUtilities.getProductConfigurationById(product.id);
        const tileClassName = "app-tile tile-lg " + (product.isLocked ? "locked" : productConfiguration.tileClassName);
        return (<a href={product.isLocked ? null : product.url} key={product.id} tabIndex={-1}>
            <div
                className={tileClassName}
                key={product.id}
                tabIndex={1}
                ref={ref => this.setRefToProduct(ref, product)}
                onKeyDown={e => this.onProductKeyDown(e, product)}
                aria-label={productConfiguration.ariaLabel}>
                <div className="app-tile-icon">
                    {this.getProductIcon(productConfiguration)}
                </div>
                <div className="app-tile-title">
                    <div>{productConfiguration.label}</div>
                </div>
            </div>
        </a>);
    }

    onProfileClick () {
        window.location = UrlHelper.getIdentifiUrl() + "ssoauth/UserProfile";
    }

    render () {
        const products = this.props.applications;
        if (products == null)
            return null;

        const surveillanceProducts = products.filter(product => ProductUtilities.isSurveillanceProduct(product.id));
        const safetyProducts = products.filter(product => ProductUtilities.isSafetyProduct(product.id));
        const tools = products.filter(product => ProductUtilities.isTools(product.id));

        const user = UsersUtility.getCurrentUser();
        const organization = user.activeOrganizations.find(o => o.id === user.organizationId);

        return (
            <div>
                <Header currentVirtualUser={user}
                    currentOrganization={organization}
                    onProfileClick={this.onProfileClick}
                    showLocationMenu={() => { }}
                    shouldUseReactRouter={false}
                    logoutUser={this._onSignOut}
                    documentationUrl={GlobalSettings.DocumentationTrainingUrl} />

                <div className="container-sm">
                    <h1 className="title">Welcome to SoleSource<small>&reg;</small></h1>
                    {surveillanceProducts.length > 0 &&
                        <div className="productBlock">
                            <h2 aria-label="Sentry Seven Surveillance">Sentri7<sup>&reg;</sup> Surveillance</h2>
                            <div className="products">{surveillanceProducts.map((product) => this.getProductTile(product))}</div>
                        </div>
                    }

                    {safetyProducts.length > 0 && <div className="productBlock">
                        <h2 aria-label="Simplify Plus Compliance">
                            Simplifi+<sup>&reg;</sup> Compliance
                        </h2>
                        <div className="products">{safetyProducts.map((product) => this.getProductTile(product))}</div>
                    </div>
                    }

                    {tools.length > 0 && <div className="productBlock">
                        <h2>
                            Tools and Extras
                        </h2>
                        <div className="products">{tools.map((product) => this.getProductTile(product))}</div>
                    </div>
                    }
                </div>
            </div>
        );
    }

    _onSignOut () {
        window.location = UrlHelper.getLogoutUrl();
    }
}

ProductSelectorContainer.defaultProps = {
    getAvailableApplications: () => { }
};

ProductSelectorContainer.propTypes = {
    getAvailableApplications: PropTypes.func
};

const mapStateToProps = state => ({
    applications: state.appState.applications
});

const mapDispatchToProps = { getAvailableApplications };

export default connect(mapStateToProps, mapDispatchToProps)(ProductSelectorContainer);
